<div class="wrapper page-heading page-heading-header-bg">
    <div class="row page-heading-left">
        <div class="col-xs-6" >
            <h1 [i18n]="'df-management.df-admin.title'" (click)="goBackAdmin()"></h1>
        </div>
    </div>
</div>

<section class="container">
    <div class="wrapper country-heading ">
        <div class="row page-heading-left">
            <div class="col-xs-6 col-sm-7">
                <h1 class="table-heading" [i18n]="'df-management.df-admin.heading.title'"></h1>
            </div>
            <div class="col-xs-6 ">
                <div class="row">
                    <div class="col-xs-6">
                        <input class="form-control input-style" [(ngModel)]="searchText" 
                            [i18n]="[{target: 'attribute:placeholder', key: 'df-management.df-admin.heading.search-placeholder'}]">
                    </div>
                    <div class="col-xs-6">
                        <button class="btn btn-primary btn-lg country-button"
                        (click)="createNewCountry()">
                        <span class="fa fa-plus"></span> 
                        &nbsp;
                        <span
                            [i18n]="'df-management.df-admin.heading.create-new-country'"></span>
                    </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<br>
<section class="container summary-panel">
    <div class="row">
        <div class="col-md-12">
            <div class="ibox float-e-margins">
                <div class="ibox-content no-padding">
                    <div class="table-responsive">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th [i18n]="'df-management.df-admin.table.country-name'"></th>
                                    <th [i18n]="'df-management.df-admin.table.country-code'"></th>
                                    <th [i18n]="'df-management.df-admin.table.time-zone'"></th>
                                    <th [i18n]="'df-management.df-admin.table.actions'"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let r of countryList | filter: searchText">
                                    <td class="tableContent">{{r.country}}</td>
                                    <td class="tableContent">{{r.country_code}}</td>
                                    <td class="tableContent">{{r.timezone}}</td>
                                    <td>
                                        <div class="chepfm-table__actions" >
                                            <button type="button" class="btn btn-info btn-sm" (click)="editCountry(r)">
                                                <i class="fa fa-caret-right vert-align-top" aria-hidden="true"></i></button>
                                        </div>
                                    </td>
                                </tr>
                                <tr *ngIf="!countryList || countryList.length === 0">
                                    <td [attr.colspan]="6" class="force-text-center"><em [i18n]="'df-management.df-admin.table.no-countries-yet'"></em></td>
                                </tr>
                                </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="overlay-form" *ngIf="isEditVisible">
    <div class="chepfm--form__collapse-wrapper"
        [ngClass]="isEditVisible ? 'chepfm--form__collapse-show' : 'chepfm--form__collapse-hide'">
        <div class="chepfm--form__collapse-header">
            <h6 class="chepfm--form__collapse-heading" >Country Details</h6>
            <div class="close-icon">
                <button type="button" class="btn btn-link" (click)="onCloseEditClick()">
                    <span _ngcontent-owx-c9="" class="fa fa-close"></span>
                </button>
            </div>
        </div>
        <app-view-country-form [countryData]="editCountryData"></app-view-country-form>
    </div>
</div>

<app-add-country-form [isFlag]="parentFlag" (countryEmitter)="getCountryData()" (countryClickEmitter)="clickCountryData()"></app-add-country-form>